<template>
  <div class="DarkWhite pa-4 ">
      <h2 class="subheading green--text">Place of Delivery</h2>
      <v-card class="mt-4">
      <PSUPlaceOfDeliveryUtility/>
  </v-card>
  </div>
</template>

<script>
import PSUPlaceOfDeliveryUtility from '../components/Utils/PSUPlaceOfDeliveryUtility.vue'
  export default {
    components: {
      PSUPlaceOfDeliveryUtility
    },
    data: () => ({
    }),
  }
</script>


<style scoped>
</style>